export const mainInitialState = {
   windowWidth: window.innerWidth

}


